import $ from 'jquery';
import Masonry from "masonry-layout";
import { debounce } from 'lodash';
export class Timeline {
    constructor() {
        this.selector = '.timeline';
        this.$timelineHeader = $(this.selector).find('.timeline-header');
        this.$timelineList = $(this.selector).find('.timeline-list');
        this.$seperator = $(this.selector).find('.timeline-seperator');
        this.timeline = null;
        if ($(this.selector).length === 0)
            return;
        this.toggleMasonry();
        this.resize();
    }
    resize() {
        $(window).on('resize', debounce(() => {
            this.toggleMasonry();
        }, 250));
    }
    toggleMasonry() {
        if (window.innerWidth >= 768) {
            if (!this.timeline) {
                this.timeline = new Masonry(this.$timelineList[0], {
                    itemSelector: '.timeline-item',
                });
            }
            if (this.timeline) {
                this.resizeSeperator();
            }
        }
        else {
            if (this.timeline) {
                this.timeline.destroy();
            }
        }
    }
    resizeSeperator() {
        const $lastTimelineItem = $(this.selector).find('.timeline-item').last();
        const $cardThumbnail = $lastTimelineItem.find('.card-thumbnail');
        const $cardContent = $lastTimelineItem.find('.card-content');
        const timelineHeaderHeight = parseInt(this.$timelineHeader.css('margin-bottom'));
        const height = this.$timelineList.outerHeight() + timelineHeaderHeight - 2.5 - (($cardThumbnail.outerHeight() / 2) + $cardContent.outerHeight());
        this.$seperator.css({ height });
    }
}
